import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";
import {sortSeoUrls} from "@/core/utils/helpers/seo/seoHelpers";

function getViewType() {
    let view = 'init';

    let path = _.get(window, 'location.pathname', '');
    path = path.substring(1, path.length - 1);

    path = this.pathWithoutRegion(path);

    let splited = path.split('/');

    if (splited[0] === 'users') {
        return 'profile';
    }

    const sortedSeoUrls = sortSeoUrls(constants.seo_url)

    _.forEach(sortedSeoUrls, (seoUrl) => {
        if (path.search(seoUrl) !== -1) {
            const exp1 = seoUrl.split('/');
            const exp2 = path.split('/');

            if (exp2.length === exp1.length || exp1.length === exp2.length - 1) {
                view = 'search';
            } else {
                view = 'profile';
            }

            return false // exit loop
        }
    });

    try {
        if (pageType) {
            view = JSON.parse(JSON.stringify(pageType));
            pageType = undefined;
        }
    } catch (e) {

    }

    return view;
}

export default {
    methods: {
        getViewType,
        sortSeoUrls,
    },
    mixins: [
        regionsUrlMixin,
    ]
}
